module.exports = __webpack_public_path__ + "img/au-qld.d85b9a28.svg";